import {
  AggregatedAnswer,
  SurveyResults,
} from "../../survey-results/survey-results-types";
import { Question, Survey } from "../survey-types";
import AggregatedAnswerComponent from "./AggregatedAnswerComponent";

interface SurveyResultsProps {
  survey: Survey;
  results: SurveyResults;
}

export const SurveyResultsTiles: React.FC<SurveyResultsProps> = ({
  results,
  survey,
}) => {
  function getQuestion(answer: AggregatedAnswer): Question {
    const q = survey.questions.find((q) => q.id === answer.questionId);
    if (!q) {
      throw new Error("Question not found: " + answer.questionId);
    }
    return q;
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,_minmax(400px,_1fr))] gap-4">
      {results.aggregatedAnswers?.map((answer) => (
        <div className="" key={answer.questionId}>
          <AggregatedAnswerComponent
            aggregatedAnswer={answer}
            question={getQuestion(answer)}
          />
        </div>
      ))}
    </div>
  );
};
